<template>
  <general-layout v-if="pageList">
    <template #header>
      <east-operate>
        <template #right>
          <el-date-picker
            v-model="time"
            type="daterange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            format="yyyy-MM-dd"
            value-format="yyyy-MM-dd"
            size="mini"
          >
          </el-date-picker>
          <el-button type="plain" title="搜索" @click="handleSearch" size="mini"
            >搜索</el-button
          >
        </template>
      </east-operate>
    </template>
    <layui-table :data="pageList.list">
      <layui-table-column
        min-width="180"
        align="left"
        label="任务类型(同步节点)"
      >
        <template slot-scope="scope">
          <span>{{ getName(scope.row.dn) }}</span>
        </template>
      </layui-table-column>
      <layui-table-column
        prop="createAdmin"
        width="80"
        align="center"
        label="操作者"
      ></layui-table-column>
      <layui-table-column width="150" align="center" label="开始时间">
        <template slot-scope="scope">
          <span>
            {{ scope.row.startTime | dateFormat("yyyy-MM-dd HH:mm:ss") }}
          </span>
        </template>
      </layui-table-column>
      <layui-table-column width="90" align="center" label="任务时长">
        <template slot-scope="scope">
          <span v-if="scope.row.endTime">
            {{
              (Date.parse(scope.row.endTime) - Date.parse(scope.row.startTime))
                | toTimer
            }}
          </span>
        </template>
      </layui-table-column>
      <layui-table-column
        prop="failed"
        width="80"
        align="center"
        label="失败(条)"
      ></layui-table-column>
      <layui-table-column prop="state" width="140" label="状态">
        <template slot-scope="scope">
          <span
            v-if="scope.row.state === TASK_STATE.Success"
            class="text-success"
          >
            {{ TASK_STATE_TEXT[scope.row.state] }}
          </span>
          <span
            v-else-if="scope.row.state === TASK_STATE.Running"
            class="text-primary"
          >
            {{ TASK_STATE_TEXT[scope.row.state] }}
          </span>
          <span v-else-if="scope.row.state === TASK_STATE.Waiting">
            {{ TASK_STATE_TEXT[scope.row.state] }}
          </span>
          <span v-else class="text-danger">
            {{ TASK_STATE_TEXT[scope.row.state] }}
          </span>
        </template>
      </layui-table-column>
      <layui-table-column
        prop="stateMessage"
        min-width="180"
        label="状态信息"
      ></layui-table-column>
      <layui-table-column prop="operate" width="80" align="center" label="操作">
        <template slot-scope="scope">
          <el-button type="text" @click="handleDetail(scope.row)">
            查看记录
          </el-button>
        </template>
      </layui-table-column>
    </layui-table>
    <template #footer>
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="currentPage"
        :page-sizes="$page.sizes"
        :page-size="size"
        layout="total, sizes, prev, pager, next"
        :total="pageList.total"
      >
      </el-pagination>
    </template>
  </general-layout>
</template>

<script>
import TASK from "@/api/sync/task";
import { mapState } from "vuex";
import { DN_PREFIX } from "@/constant/extensionTask";
import { TASK_STATE, TASK_STATE_TEXT } from "@/constant/taskState";
export default {
  props: {
    timer: Boolean,
    page: { type: [String, Number], default: 1 }
  },
  data() {
    return {
      DN_PREFIX,
      TASK_STATE,
      TASK_STATE_TEXT,
      size: this.$page.size,
      pageList: null,
      serviceDic: {},
      time: [],
      etime: null,
      stime: null
    };
  },
  computed: {
    ...mapState(["descriptors"]),
    currentPage: vm => Number(vm.page),
    getName: vm => dn => {
      if (dn.startsWith(DN_PREFIX)) {
        let name = dn.slice(DN_PREFIX.length);
        return vm.serviceDic[name] ?? name;
      } else {
        return dn;
      }
    }
  },
  async created() {
    // 等待Store初始化完成
    await this.$store.init;
    this.serviceDic = this.descriptors.reduce(
      (o, d) => ({ ...o, [d.name]: d.friendlyName }),
      {}
    );
    this.fetchData();
  },
  watch: {
    page: "fetchData",
    timer: "fetchData"
  },
  methods: {
    async fetchData() {
      let response = await TASK.HISTORY({
        timer: this.timer,
        page: this.page,
        size: this.size,
        stime: this.stime,
        etime: this.etime
      });
      if (response.data.state) {
        if (this.currentPage !== response.data.pageList.page) {
          this.$router.push({
            query: { ...this.$route.query, page: response.data.pageList.page }
          });
        } else {
          this.pageList = response.data.pageList;
        }
      }
    },
    handleSizeChange(size) {
      this.size = size;
      this.fetchData();
    },
    handleCurrentChange(page) {
      this.$router.push({
        query: { ...this.$route.query, page }
      });
    },
    handleSearch() {
      this.stime = this.time[0];
      this.etime = this.time[1];
      this.fetchData();
    },
    handleDetail(row) {
      this.$router.push({
        name: "任务详情",
        params: { id: row.id }
      });
    }
  }
};
</script>

<style scoped>
.el-date-editor {
  position: relative;
  top: 1px;
  margin-right: 10px;
}
</style>
